var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1040_101424)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1040_101424)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1040_101424",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V14H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1040_101424)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1040_101424",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V14H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1040_101424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.56464 6.99984L13.2896 2.27775C13.4767 2.06637 13.576 1.7916 13.5674 1.50949C13.5588 1.22738 13.4429 0.959199 13.2433 0.759623C13.0437 0.560048 12.7755 0.444118 12.4934 0.435504C12.2113 0.426889 11.9365 0.52624 11.7251 0.713267L7.0013 5.43535L2.27922 0.713267C2.179 0.599996 2.05665 0.508422 1.91972 0.444209C1.78278 0.379995 1.63415 0.344488 1.48298 0.339872C1.33181 0.335256 1.18129 0.361642 1.04069 0.417381C0.900092 0.47312 0.772389 0.557046 0.665444 0.663991C0.558498 0.770937 0.474573 0.89864 0.418833 1.03924C0.363094 1.17984 0.336721 1.33035 0.341337 1.48153C0.345953 1.6327 0.38146 1.78133 0.445674 1.91826C0.509887 2.0552 0.601448 2.17753 0.714719 2.27775L5.4368 6.99984L0.714719 11.7219C0.605182 11.8232 0.517205 11.9455 0.456058 12.0815C0.39491 12.2175 0.36185 12.3645 0.358858 12.5136C0.355866 12.6628 0.383003 12.811 0.438645 12.9493C0.494286 13.0877 0.577287 13.2135 0.682675 13.319C0.788063 13.4245 0.913669 13.5077 1.05197 13.5636C1.19027 13.6194 1.33842 13.6468 1.48755 13.644C1.63668 13.6413 1.78371 13.6084 1.91984 13.5475C2.05598 13.4865 2.17841 13.3987 2.2798 13.2893L7.0013 8.56434L11.7234 13.2893C11.8252 13.3969 11.9476 13.4829 12.0833 13.5423C12.2189 13.6017 12.3651 13.6333 12.5132 13.6353C12.6613 13.6373 12.8083 13.6095 12.9455 13.5538C13.0827 13.498 13.2073 13.4152 13.312 13.3105C13.4166 13.2057 13.4993 13.081 13.555 12.9438C13.6106 12.8066 13.6383 12.6596 13.6362 12.5115C13.6341 12.3634 13.6024 12.2172 13.5428 12.0816C13.4833 11.946 13.3972 11.8237 13.2896 11.7219L8.56464 6.99984Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1040_101424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1040_101424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.c5c5859041175bc330f989b16108cc55.svg";
export { ForwardRef as ReactComponent };